import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { TRoutes } from '../../shared/const'

import PoweredBy from '../PoweredBy'

import styles from './style.module.scss'

/*
 * Fusszeile der oeffentlichen Seiten (Startseite + Rechtsseiten). Verlinkt die
 * vier Rechtsseiten intern (statt wie frueher externe junior.cc-Seite und
 * statische PDF). „Powered by DaVinciLab" oeffnet seit 25.08.2026 einen kurzen
 * Steckbrief statt davincilab.at — siehe components/PoweredBy.
 *
 * **Der Inhalt liegt in einem eigenen Kasten, die Leiste nur darum** — wie bei
 * der Kopfleiste. So laeuft der navy Grund ueber die volle Breite, waehrend
 * sich die Verweise an der Spalte der Seite ausrichten koennen (`spalte`).
 */
function PublicFooter({ spalte }) {
	const { t } = useTranslation()

	return (
		<footer className={styles.root}>
			<div className={clsx(styles.inner, spalte && styles.innerSpalte)}>
				<nav className={styles.links} aria-label={t('Legal information')}>
					<Link className={styles.link} to={TRoutes.IMPRESSUM}>
						{t('Imprint')}
					</Link>
					<Link className={styles.link} to={TRoutes.DATENSCHUTZ}>
						{t('Privacy policy')}
					</Link>
					<Link className={styles.link} to={TRoutes.NUTZUNGSBEDINGUNGEN}>
						{t('Terms of use')}
					</Link>
					<Link className={styles.link} to={TRoutes.BARRIEREFREIHEIT}>
						{t('Accessibility')}
					</Link>
				</nav>
				<PoweredBy className={styles.powered} />
			</div>
		</footer>
	)
}

PublicFooter.propTypes = {
	/*
	 * Inhalt in dieselbe mittige Spalte wie der Seiteninhalt. Nur fuer Seiten,
	 * die selbst so gebaut sind — Startseite und Berichtsseiten laufen ueber die
	 * volle Breite.
	 */
	spalte: PropTypes.bool
}

PublicFooter.defaultProps = { spalte: false }

export default PublicFooter
